import { ACMEResponse } from '@b2b/types/core';
import angular, { IPromise } from 'angular';

export interface RateCardPricing {
  percentage: number;
  additionalAmount: number;
}

export interface RateCard {
  id: string;
  saleChannel: string;
  creditCardBrand: string | null;
  pricing: RateCardPricing;
  displayBrand?: string;
}

export class RateCardsApiService {
  static $inject = ['$http'];

  service = '/v2/api/ratecards';

  constructor(private $http: ng.IHttpService) {}

  init(_endpoint: string) {
    return this;
  }

  list(): IPromise<{ data: ACMEResponse<RateCard[]> }> {
    return this.$http<ACMEResponse<RateCard[]>>({ method: 'get', url: this.service });
  }
}

export const RateCardsApiServiceModule = angular
  .module('acme.common.service.rateCardsApi', [])
  .service('RateCardsApiService', RateCardsApiService).name;
